import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { broadcastQueryData } from 'src/composables/app/system/useBroadcastChannel'
import { userService } from 'src/services/api/user.service'
import { log } from 'src/services/app/log.service'
import { notifyMsgs, notifyService } from 'src/services/app/notify.service'
import { MUTATION_KEYS, QUERY_KEYS } from 'src/services/consts/queries.const'
import { wrapMutationAsync } from 'src/services/app/util.service'

/**
 * Sends a verification code to a new additional email address.
 * Re-calling with the same address re-sends the code, so the success copy
 * fits both first send and resend. The service only resolves
 * `verification_sent` with user info; the actions wrapper opens verify.
 */
export function useAddAdditionalEmailMutation() {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationKey: [MUTATION_KEYS.ADD_ADDITIONAL_EMAIL],
    mutationFn: ({ email }) => userService.addAdditionalEmail({ email }),

    onSuccess: (envelope) => {
      if (envelope.userInfo != null) {
        queryClient.setQueryData([QUERY_KEYS.USER_INFO], envelope.userInfo)
        broadcastQueryData([QUERY_KEYS.USER_INFO], envelope.userInfo)
      }
      notifyService.success(notifyMsgs.success.additionalEmailCodeSent)
    },

    onError: (error) => {
      log.error('[AddAdditionalEmail] Failed to send verification code', error)
      notifyService.error(notifyMsgs.error.addAdditionalEmail)
    },
  })

  return {
    addAdditionalEmail: wrapMutationAsync(mutation.mutateAsync),
    isAddingAdditionalEmail: mutation.isPending,
  }
}
